import { render, staticRenderFns } from "./PurchasingApproval.vue?vue&type=template&id=5682930e&scoped=true&"
import script from "./PurchasingApproval.vue?vue&type=script&lang=js&"
export * from "./PurchasingApproval.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingApproval.vue?vue&type=style&index=0&id=5682930e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5682930e",
  null
  
)

export default component.exports